/**
 * @generated SignedSource<<98c195128dbc72e12a5687ecabbb6d67>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateConfigurationTaskQueuePayload",
    "kind": "LinkedField",
    "name": "updateConfigurationTaskQueue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "configurationTaskMetrics",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfigurationTask",
        "kind": "LinkedField",
        "name": "configurationTask",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "queue",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateConfigurationTaskQueueMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateConfigurationTaskQueueMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "afbaf968cf18ae30fe689b8d4d2598ef",
    "id": null,
    "metadata": {},
    "name": "UpdateConfigurationTaskQueueMutation",
    "operationKind": "mutation",
    "text": "mutation UpdateConfigurationTaskQueueMutation(\n  $input: UpdateConfigurationTaskQueueInput!\n) {\n  updateConfigurationTaskQueue(input: $input) {\n    viewer {\n      configurationTaskMetrics\n    }\n    configurationTask {\n      id\n      queue\n    }\n  }\n}\n"
  }
};
})();

node.hash = "03f9c81651a2996cc3effd906a585989";

module.exports = node;
